













































































import { ContactContext } from '@spa/components/organisms/contact/model/context/contact-context'
import { ContactOnOrderPageContext } from '@spa/components/organisms/contact/model/context/contact-on-order-page/contact-on-order-page-context'
import { OrderContext } from '@spa/components/pages/order/model/context/order-context'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import ContactItem from '@spa/components/organisms/contact/ContactItem.vue'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

@Component({
  components: {
    ContactItem,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Index extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  context: OrderContext

  status: Status = Status.Pending

  get user(): User {
    return this.$store.state.user.user
  }

  get cancelUrl(): string {
    return this.context.path.confirmPage
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get errorOnLoad() {
    return _.get(this.$store.state.contact.error, 'load')
  }

  get contacts() {
    // TODO: Need to sort?
    return this.$store.state.contact.items
  }

  get delivery() {
    return this.$store.state.orderConfirm.delivery
  }

  get contactContext(): ContactContext {
    return ContactOnOrderPageContext.buildFromOrderContext(this.context)
  }

  async use(id: string) {
    await this.$store.dispatch('orderConfirm/initializeDelivery', { id })

    this.$router.push(this.context.path.confirmPage)
  }

  async created() {
    this.status = Status.Loading

    await Promise.all([
      this.$store.dispatch('contact/load'),
      this.$store.dispatch('user/get'),
    ])

    if (this.errorOnLoad) {
      this.status = Status.Failed

      return
    }

    this.status = Status.Completed

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }
}
